import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'

const model = (payload) => ({
  id: payload.id,
  name: payload.name
})

const crud = new Crud('ErrorCatalogs', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  errorCatalogs: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  errorCatalogs: state => state.errorCatalogs
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
